export interface ILabTest {
    id: number;
    dateOrdered: Date;
    dateMeasured: Date;
    description: string;
    specimen: string;
    biomarkerId: number;
    value: number;
    unit: string;
}

export class LabTest implements ILabTest {
    id: number;
    dateOrdered: Date;
    dateMeasured: Date;
    description: string;
    specimen: string;
    biomarkerId: number;
    value: number;
    unit: string;

    constructor(data: ILabTest) {
        this.id = data.id;
        this.dateOrdered = new Date(data.dateOrdered);
        this.dateMeasured = new Date(data.dateMeasured);
        this.description = data.description;
        this.specimen = data.specimen;
        this.biomarkerId = data.biomarkerId;
        this.value = data.value;
        this.unit = data.unit;
    }
}
